<template>
  <v-fade-transition hide-on-leave>
    <v-card
      v-if="questions"
      class="pa-5 mb-5"
      light
      width="100%"
    >
      <v-container>
        <v-row>
          <v-col cols="1">
            <v-btn icon @click="$router.go(-1)">
              <v-icon color="blue">
                mdi-arrow-left
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-row class="mb-10" justify="center">
        <template v-if="examStatus.qualify === 1">
          <v-card-title>
            {{ currentUnit.courseTitle }} 第{{ currentUnit.systemUnitNumber }}単元 確認テスト結果
          </v-card-title>
        </template>
        <template v-else>
          <v-card-title>
            {{ currentUnit.courseTitle }} 第{{ currentUnit.systemUnitNumber }}単元 確認テスト
          </v-card-title>
        </template>
      </v-row>
      <template v-if="examStatus.qualify !== 1">
        <template v-if="isTestFinished">
          <test-result :is-unit-pass="isUnitPass" :correct-answer-num="correctAnswerNum" :question-num="questions[0].numOfQuestions" />
        </template>
        <div v-if="isUnitPass">
          <div v-for="(question,index) in correctAnswer" :key="`question-${index}`">
            <question :question-data="question" :is-test-finished="isTestFinished" :test-result="testResult" :exam-qualified="true" @answerQuestion="answerQuestion($event)" />
          </div>
        </div>
        <div v-else>
          <div v-for="(question,index) in questions" :key="`question-${index}`">
            <question :question-data="question" :is-test-finished="isTestFinished" :test-result="testResult" @answerQuestion="answerQuestion($event)" />
          </div>
        </div>
      </template>
      <template v-else>
        <test-result :is-unit-pass="true" :correct-answer-num="pastCorrectAnswerNum" :question-num="questions[0].numOfQuestions" />
        <div v-for="(question,index) in correctAnswer" :key="`question-${index}`">
          <question :question-data="question" :is-test-finished="isTestFinished" :test-result="pastTestResult" :exam-qualified="true" @answerQuestion="answerQuestion($event)" />
        </div>
      </template>
      <v-dialog
        v-model="dialog"
        width="300"
      >
        <template v-if="examStatus.qualify !== 1" v-slot:activator="{ on, attrs }">
          <v-row class="justify-center">
            <v-btn
              v-bind="attrs"
              class="mt-5"
              :disabled="isTestFinished"
              v-on="on"
            >
              解答を提出する
            </v-btn>
          </v-row>
        </template>

        <v-card>
          <v-card-title class="text-h5 justify-center">
            確認
          </v-card-title>
          <v-divider class="mb-5" />
          <v-card-text class="text-center">
            解答を送信しますか？
          </v-card-text>
          <v-card-text class="text-center">
            一度送信すると、修正は出来ません。
          </v-card-text>
          <v-card-text class="text-center">
            ※送信ボタンは1度だけクリック
          </v-card-text>
          <v-divider />

          <v-card-actions class="justify-center">
            <v-btn
              color="primary"
              text
              @click.once="finishTest"
            >
              送信
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-fade-transition>
</template>

<script>
import Question from '@/components/pages/unitTest/Question.vue'
import TestResult from '@/components/pages/unitTest/TestResult.vue'
import axios from 'axios'
import { mapState } from 'vuex'
import store from '@/store/store'
import repository from '@/store/repository'
import handleApiError from '@/plugins/handleApiError'

export default {
  name: 'UnitTest',
  components: {
    Question,
    TestResult
  },
  data () {
    return {
      dialog: false,
      questions: null,
      units: require(`@/assets/courseData/courseUnits/${this.$route.params.courseId}.json`),
      lessons: require(`@/assets/courseData/courseSections/${this.$route.params.courseId}/unit${this.$route.params.unitId}.json`),
      currentUnit: null,
      currentCourse: null,
      userAnswers: [],
      isUnitPass: null,
      testResult: null,
      isTestFinished: false,
      pastTestResult: null,
      examStatus: { qualify: 0 },
      correctAnswerNum: 0,
      correctAnswer: null,
      pastCorrectAnswerNum: 0
    }
  },
  computed: {
    ...mapState(['user'])
  },
  async created () {
    const courseId = this.$route.params.courseId
    const courseData = require('@/assets/courseData/courseCards.json')
    this.currentUnit = this.units.find((unit) => unit.systemUnitNumber === parseInt(this.$route.params.unitId))
    this.currentCourse = courseData.find((course) => course.systemName === courseId)
    await this.checkCompletionTest()
    if (this.examStatus.qualify) {
      await this.getPastTestResult()
      await this.getCorrectAnswer()
    }
  },
  async mounted () {
    const courseId = this.$route.params.courseId
    const courseData = require('@/assets/courseData/courseCards.json')
    this.currentUnit = this.units.find((unit) => unit.systemUnitNumber === parseInt(this.$route.params.unitId))
    this.currentCourse = courseData.find((course) => course.systemName === courseId)

    await this.getQuestion()
    this.checkTestStatus()

    for (let questionNum = 1; questionNum < this.questions.length + 1; questionNum++) {
      this.userAnswers.push(
        {
          questionNum: questionNum,
          choices: [null, null, null, null, null, null, null, null]
        }
      )
    }
  },
  methods: {
    async getQuestion () {
      const reqUrl = process.env.VUE_APP_GET_QUESTIONS_URL
      const reqBody = {
        courseId: String(this.currentCourse.courseId),
        unitNum: String(this.currentUnit.systemUnitNumber)
      }
      const header = {
        headers: {
          'x-api-key': process.env.VUE_APP_DB_API_KEY,
          'Content-Type': 'application/json',
          Authorization: repository.getAccessToken()
        }
      }

      const res = await axios.post(reqUrl, reqBody, header).catch(handleApiError)
      this.questions = res.data
    },
    async testScoring () {
      const reqUrl = process.env.VUE_APP_SCORING_API_URL
      const reqBody = {
        pjmUserId: Number(repository.getPjmUserId()),
        cognitoUsername: store.state.username,
        cognitoIdToken: repository.getIdToken(),
        courseId: Number(this.currentCourse.courseId),
        unitNum: Number(this.currentUnit.systemUnitNumber),
        userAnswers: this.userAnswers
      }
      const header = {
        headers: {
          'x-api-key': process.env.VUE_APP_DB_API_KEY,
          'Content-Type': 'application/json',
          Authorization: repository.getAccessToken()
        }
      }

      const res = await axios.post(reqUrl, reqBody, header).catch(handleApiError)

      this.isUnitPass = res.data.unitPass === 1
      if (this.isUnitPass) {
        this.testResult = res.data
        this.getCorrectAnswer()
      }
      this.countCorrect(res.data)
    },
    async checkCompletionTest () {
      const reqUrl = process.env.VUE_APP_CHECK_COMPLETION_API_URL
      const reqBody = {
        checkType: 'unit',
        pjmUserId: String(repository.getPjmUserId()),
        cognitoUsername: store.state.username,
        cognitoIdToken: repository.getIdToken(),
        courseId: String(this.currentCourse.courseId),
        unitNum: String(this.currentUnit.systemUnitNumber)
      }
      const header = {
        headers: {
          'x-api-key': process.env.VUE_APP_DB_API_KEY,
          'Content-Type': 'application/json',
          Authorization: repository.getAccessToken()
        }
      }

      const result = await axios.post(reqUrl, reqBody, header).catch(handleApiError)
      this.examStatus = result.data
    },
    async getPastTestResult () {
      const reqUrl = process.env.VUE_APP_GET_PASTANS_URL
      const reqBody = {
        pjmUserId: Number(repository.getPjmUserId()),
        cognitoUsername: store.state.username,
        cognitoIdToken: repository.getIdToken(),
        examHistoryId: Number(this.examStatus.examHistoryId)
      }
      const header = {
        headers: {
          'x-api-key': process.env.VUE_APP_DB_API_KEY,
          'Content-Type': 'application/json',
          Authorization: repository.getAccessToken()
        }
      }

      const res = await axios.post(reqUrl, reqBody, header).catch(handleApiError)
      this.pastTestResult = res.data
      this.countPastCorrect(res.data)
    },
    async getCorrectAnswer () {
      const reqUrl = process.env.VUE_APP_GET_CORRECTANS_URL
      const reqBody = {
        courseId: String(this.currentCourse.courseId),
        unitNum: String(this.currentUnit.systemUnitNumber)
      }
      const header = {
        headers: {
          'x-api-key': process.env.VUE_APP_DB_API_KEY,
          'Content-Type': 'application/json',
          Authorization: repository.getAccessToken()
        }
      }

      const result = await axios.post(reqUrl, reqBody, header).catch(handleApiError)
      this.correctAnswer = result.data
    },
    answerQuestion (answer) {
      let choices = answer.choices
      if (!Array.isArray(answer.choices)) {
        choices = [choices]
      } else {
        choices = choices.slice()
      }
      choices.sort(function (a, b) {
        return (a < b ? -1 : 1)
      })
      for (let i = 0; i < 8; i++) {
        if (choices[i] === undefined) {
          choices[i] = null
        }
      }
      this.userAnswers
        .find(data => data.questionNum === answer.questionNum)
        .choices = choices
    },

    checkTestStatus () {
      if (this.examStatus.qualify === 1) {
        this.isTestFinished = true
      } else {
        this.isTestFinished = false
      }
    },

    async finishTest () {
      this.isTestFinished = true
      await this.testScoring()
      this.dialog = false
      this.moveToTop()
    },

    countCorrect (result) {
      result.userAnswers.forEach(userAnswer => {
        this.correctAnswerNum += userAnswer.correct
      })
    },

    countPastCorrect (result) {
      result.userAnswers.forEach(userAnswer => {
        this.pastCorrectAnswerNum += userAnswer.correct
      })
    },

    moveToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>
